import { WidgetDefinition } from '../models/WidgetDefinition';

export const tileWidgetDefinition: WidgetDefinition = {
    baseType: 'Tile',
    group: 'Others',
    hasImage: true,
    highlights: ['Aggregated value of identifiers shown as numbers', 'You can also show its name, units or highlight the tile according to alarms'],
    icon: 'fa-square',
    sortingOrder: 800,
    title: 'Tile',
    type: 'Tile'
};